<script>
import design from '@design'

export default {
  props: {
    category: {
      type: String,
      required: true,
    },
  },
  computed: {
    appBackgroundColor() {
      const defaultColor = design['secondary-light-blue']
      const category = this.category ? this.category.toLowerCase() : ''
      const categoryColors = {
        research: design['secondary-orange'],
        tools: design['secondary-green'],
        marketplace: design['secondary-red'],
        bookmarks: design['secondary-light-blue'],
      }

      return categoryColors[category] || defaultColor
    },
  },
}
</script>

<template>
  <div :class="$style.appTag" class="tag-text" :style="{ 'background-color': appBackgroundColor }">{{ category }}</div>
</template>

<style lang="scss" module>
@import '@design';

.appTag {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 22px;
  padding: 2px 16px;
  color: $white;
  border: 1px solid $white;
  border-radius: 50px;
}
</style>
